import * as ApiModels from '@typings/api-models';

type Expression = Pick<ApiModels.Expression, 'expression' | 'filterExpression' | 'filterExpressionVariableName' | 'filterExpressionOperand' | 'filterExpressionItemSelector' | 'filterExpressionReducer'> & {
  variables: Pick<ApiModels.ExpressionVariable, 'variableName' | 'referenceId' | 'referenceType' | 'selector'>[];
};

const makeDefaultExpression = (): Expression => ({
  expression: '',
  filterExpression: null,
  filterExpressionItemSelector: null,
  filterExpressionOperand: null,
  filterExpressionReducer: null,
  filterExpressionVariableName: null,
  variables: [],
});

export default makeDefaultExpression;